var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PDFDocument',{key:_vm.updatePdf,staticStyle:{"text-align":"center"},attrs:{"name":_vm.$route.params.name,"fileLang":_vm.$route.params.lang}})
}
var staticRenderFns = []

export { render, staticRenderFns }